import { Point, distance } from "@noya-app/noya-geometry";

export const DEFAULT_MOVEMENT_THRESHOLD = 2;

export function isMoving(
  current: Point,
  origin: Point,
  zoomValue: number,
  threshold: number
): boolean {
  threshold = threshold / zoomValue;

  return distance(current, origin) >= threshold;
}
